module.exports = __webpack_public_path__ + "img/12.ea3c10bf.jpg";